export const DELIVERY_PARTNERS_CACHE_KEY = "dyn_delivery_partners_cache";

export type PartnerOption = {
  id: number;
  name: string;
  is_on_duty?: boolean;
};

export type CachedDeliveryPartners = {
  drivers: PartnerOption[];
  depots: PartnerOption[];
  updatedAt?: string;
};

const EMPTY_CACHE: CachedDeliveryPartners = {
  drivers: [],
  depots: [],
};

export function loadDeliveryPartnersFromStorage(): CachedDeliveryPartners | null {
  try {
    const raw = localStorage.getItem(DELIVERY_PARTNERS_CACHE_KEY);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw) as CachedDeliveryPartners;
    if (
      !parsed ||
      !Array.isArray(parsed.drivers) ||
      !Array.isArray(parsed.depots)
    ) {
      return null;
    }

    return {
      drivers: parsed.drivers,
      depots: parsed.depots,
      updatedAt: parsed.updatedAt,
    };
  } catch {
    return null;
  }
}

export function saveDeliveryPartnersToStorage(
  drivers: PartnerOption[],
  depots: PartnerOption[]
): void {
  const payload: CachedDeliveryPartners = {
    drivers,
    depots,
    updatedAt: new Date().toISOString(),
  };

  try {
    localStorage.setItem(DELIVERY_PARTNERS_CACHE_KEY, JSON.stringify(payload));
    localStorage.setItem("partnerId", JSON.stringify({ results: drivers }));
  } catch {
    // Ignore when iframe storage is blocked (mobile Safari).
  }
}

export function getInitialDeliveryPartnersState(): CachedDeliveryPartners {
  return loadDeliveryPartnersFromStorage() ?? EMPTY_CACHE;
}
